<template>
  <div
    class="battle w-full market grid grid-cols-1 md:flex md:justify-start gap-2 md:gap-2 leading-snug transform scale-75 -ml-16 md:ml-0 md:scale-100 -mb-16 md:mb-0 pl-8 md:pl-0"
    id="items"
  >
    <div class="gem menuItem" v-for="gem in attacks" v-bind:key="gem.id">
      <div class="">
        <div class="flex flex-rol items-center pl-4 mb-2">
          <img
            :src="gem.image"
            class="h-12 item cursor-move ml-1 mt-1"
            alt
            :gem_id="gem.id"
            :gen_score="gem.score"
            :gem_days="gem.days"
          />
          <div class="text-white text-3xl mb-0 ml-4">{{ gem.name }}</div>
        </div>
        <div class="flex flex-row space-x-8 pl-8">
          <div
            class="flex flex-col text-base items-center font-light text-yellow-400"
          >
            <span class="text-green-300 text-xs">ROYAL</span>
            <span class="text-green-300 text-lg">+{{ gem.adds }}</span>
          </div>
          <div
            class="flex flex-col text-base items-center font-light text-yellow-400"
          >
            <span class="text-xs">TOD</span>
            <span class="">-{{ gem.tod }} hours</span>
          </div>
          <div
            class="flex flex-col text-base items-center font-light text-yellow-400"
          >
            <span class="text-xs uppercase">Costs</span>
            <span class="">{{ gem.price }} eth</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Battle",
  components: {},
  props: {
    address: String,
  },
  data: function () {
    return {
      inBattle: false,
      attacks: [
        {
          name: "Sword",
          id: 0,
          adds: 2,
          tod: 1,
          price: 0.001,
          priceInWei: "1000000000000000",
          image: require("@/assets/img/items/sword.svg"),
        },
        {
          name: "Spear",
          id: 1,
          adds: 22,
          tod: 4,
          price: 0.01,
          priceInWei: "10000000000000000",
          image: require("@/assets/img/items/spear.svg"),
        },
        {
          name: "Bomb",
          id: 2,
          adds: 230,
          tod: 24,
          price: 0.1,
          priceInWei: "100000000000000000",
          image: require("@/assets/img/items/bomb.svg"),
        },
        {
          name: "Rug pull",
          id: 3,
          adds: 2690,
          tod: 24,
          price: 1,
          priceInWei: "1000000000000000000",
          image: require("@/assets/img/items/rug.svg"),
        },
      ],
    };
  },
  methods: {
    battle: async function (opponentId) {
      this.inBattle = true;

      // to help make animation work
      // this.$store.commit("setInBattleId", opponentId);

      // alert(this.$store.state.inBattleId);

      // setTimeout(() => {
      //   this.$store.commit("setInBattleId", null);

      //   this.inBattle = false;
      // }, 5000);

      // send battle tx
      let minetx = await this.$store.state.GameContract.methods
        .attackPlayer(opponentId, this.currentGem.id)
        .send({
          from: this.$store.state.account,
          value: this.currentGem.priceInWei,
        });
    },
    setupDragAndDrop: async function (context) {
      const containers = document.querySelectorAll("#items");
      const dropzone = document.querySelector(".flip-box .flip-box-inner");

      var sword = new Audio(require("../assets/audio/sword.wav"));
      var bomb = new Audio(require("../assets/audio/bomb.wav"));
      var rugPull = new Audio(require("../assets/audio/rugPull.mp3"));
      var spear = new Audio(require("../assets/audio/spear.wav"));
      var after = new Audio(require("../assets/audio/win.wav"));

      var gem = new Draggable.Draggable(containers, {
        draggable: ".item",
        mirror: {
          appendTo: "body",
        },
      });
      gem.on("drag:start", (e) => {
        let elem = e.source.getAttribute("gem_id");
        for (const gem of this.attacks) {
          if (gem.id == parseInt(elem)) {
            this.currentGem = gem;
            // console.log(gem);
          }
        }

        if (this.currentGem.id == 0) sword.play();
        if (this.currentGem.id == 1) spear.play();
        if (this.currentGem.id == 2) bomb.play();
        if (this.currentGem.id == 3) rugPull.play();
      });

      gem.on("drag:stop", () => {
        //  console.log("stop");
      });

      let over = {};
      gem.on("drag:move", (dragMoveEvent) => {
        if (
          dragMoveEvent.sensorEvent.target.classList.contains("dropzone") ||
          dragMoveEvent.sensorEvent.target.classList.contains("dropzone2")
        ) {
          // dropzone.classList.add("rotate"); //to add rotation
          over = {
            pick: dragMoveEvent.sensorEvent.target.getAttribute("data-id"),
            isOver: true,
          };
        } else {
          over.isOver = false;
        }
      });

      gem.on("mirror:destroy", () => {
        if (over.isOver) {
          // console.log("mirror:destroy OVER");

          // we set drag to false
          over.isOver = false;

          //we send the gem picked
          this.battle(over.pick);
          after.play();
          // //   } else {
          // alert("You don't have enought muse to get this gem.");
          // //   }
        }

        if (dropzone.classList.contains("rotate")) {
          dropzone.classList.remove("rotate");
        }
      });
    },
  },
  beforeMount: function () {},
  mounted: function () {
    const context = this;

    setTimeout(() => {
      this.setupDragAndDrop(context);
    }, 1000);
  },
  watch: {},
  computed: {},
};
</script>

<style scoped>
</style>







